import React, { useState, ReactNode } from "react"
import "./style/pause-motion-wrapper.scss"
import { FiPause } from "@ng-mw/reol/icon-components/FiPause"
import { FiPlay } from "@ng-mw/reol/icon-components/FiPlay"

type PauseMotionWrapperProps = {
    children: ReactNode
}

export default function PauseMotionWrapper({ children }: PauseMotionWrapperProps) {
    const [isPaused, setIsPaused] = useState(false)

    const handlePausePlayClick = () => {
        setIsPaused(prev => !prev)
    }

    return (
        <div className={`pause-motion-wrapper ${isPaused ? "pause-motion-wrapper--stop" : ""}`}>
            <button
                aria-label={isPaused ? "Start animasjon" : "Stopp animasjon"}
                onClick={handlePausePlayClick}
                className="pause-motion-wrapper__button"
            >
                {!isPaused ? (
                    <FiPause
                        width="18px"
                        height="auto"
                    />
                ) : (
                    <FiPlay
                        width="18px"
                        height="auto"
                    />
                )}
            </button>
            {children}
        </div>
    )
}
